import { useCallback, RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { focusToCell } from "src/utils/grid/GridHandlerContent";
import { PRD1010_R01Dto } from "../Dto_PRD1010_R01";

interface UsePRD1010_R01ModalProps {
	PRD1010_R01List: PRD1010_R01Dto[];
	updatePRD1010_R01List: (index: number, data: PRD1010_R01Dto) => void;
	originalPRD1010_R01List: PRD1010_R01Dto[];
	gridRef: RefObject<AgGridReact<PRD1010_R01Dto> | null>;
}

export function usePRD1010_R01Modal({
	PRD1010_R01List,
	updatePRD1010_R01List,
	originalPRD1010_R01List,
	gridRef,
}: UsePRD1010_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);



	
	const settingCodeSearchModalProps = useCallback(
		(
			category: string,
			search: string,
			isInfo: boolean,
			handleFocusId: string,
			originalData: PRD1010_R01Dto,
			valueIndex: number,
		) => {
			const handleClear = () => {
				const updateData: Partial<PRD1010_R01Dto> = {
					...originalData,
					isModified: originalData.inserted ? false : true,
				};

				if (handleFocusId === "itemCd") {
					updateData.itemCd = "";
					updateData.itemNm = "";
					updateData.itemSpec = "";
					updateData.itemUnit = "";
				}

				updatePRD1010_R01List(valueIndex, updateData as PRD1010_R01Dto);
				handlePopupClose();
			};

			const wrapperOptionMap: Record<string, { size: string; width: number; overlay: boolean }> = {
				itemCd: { size: "md", width: 50, overlay: true },
			};

			setCodeSearchModalProps({
				category,
				search,
				formName: "PRD1010_R01",
				isInfo,
				handleFoucsId: handleFocusId,
				onClear: handleClear,
				onConfirm: (data: any) => {
					const currentRow =
						PRD1010_R01List.find((item) => item.valueIndex === valueIndex) ??
						originalPRD1010_R01List.find((item) => item.valueIndex === valueIndex) ??
						originalData;

					const updateData: Partial<PRD1010_R01Dto> = {
						...currentRow,
						isModified: originalData.inserted ? false : true,
					};

					if (handleFocusId === "itemCd") {
						updateData.itemCd = data.itemCd ?? "";
						updateData.itemNm = data.itemNm ?? "";
						updateData.itemSpec = data.itemSpec ?? "";
						updateData.itemUnit = data.itemUnit ?? "";
					}

					updatePRD1010_R01List(valueIndex, updateData as PRD1010_R01Dto);

					setTimeout(() => {
						if (!gridRef.current) return;
						if (handleFocusId === "itemCd") {
							focusToCell(gridRef, valueIndex, "planQty");
						}
					}, 100);
				},
				wrapperOption: wrapperOptionMap[handleFocusId] ?? { size: "md", width: 50, overlay: true },
			});
		},
		[
			setCodeSearchModalProps,
			updatePRD1010_R01List,
			PRD1010_R01List,
			originalPRD1010_R01List,
			gridRef,
			handlePopupClose,
		],
	);

	return {
		settingCodeSearchModalProps,
		handlePopupClose,
	};
}
